import React from "react";

const Social = () => {
  return (
    <div className="home__social">
      <a href="https://www.linkedin.com/in/shashidharsangepu/" className="home__social-icon" target="_blank" rel="noreferrer">
        <i class="uil uil-linkedin-alt"></i>
      </a>
      <a
        href="https://github.com/Shashi5657"
        className="home__social-icon"
        target="_blank" rel="noreferrer"
      >
        <i class="uil uil-github-alt"></i>
      </a>
      <a
        href="https://www.instagram.com/mr.villain29/"
        className="home__social-icon"
        target="_blank" rel="noreferrer"
      >
        <i className="uil uil-instagram"></i>
      </a>
    </div>
  );
};

export default Social;
